import { HubConnectionState } from '@microsoft/signalr';
import { GameLiveConnectionMethod } from '../../../services/liveConnection';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { crashGameService } from '../crashService/gameService';
import { crashGameStore } from '../crashStore/gameStore';
import { applicationStore } from '../../../store/applicationStore';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

let timeoutId;
let start = Number(new Date());
const pingInterval = 700;

export class CrashGameConnection {
  sendCashOut(data) {
    return mainGameConnection.invoke(GameLiveConnectionMethod.CashOut, data);
  }

  sendPing() {
    if (mainGameConnection.connection?.state === HubConnectionState.Connected) {
      start = Number(Date.now());
      crashGameStore.setIsPongReceived(false);
      mainGameConnection.ping();
      timeoutId = setTimeout(() => {
        if (!crashGameStore.isPongReceived) {
          crashGameStore.updateSlowConnection(true);
        }
      }, pingInterval);
    } else {
      applicationStore.setIsConnectionLost(true);
    }
  }

  getPong() {
    const currentTime = Number(Date.now()) - start;
    crashGameStore.setIsPongReceived(true);
    if (currentTime > 700) {
      crashGameStore.updateSlowConnection(true);
      timeoutId && clearTimeout(timeoutId);
    } else {
      crashGameStore.updateSlowConnection(false);
    }
  }

  executeGameConnections() {
    mainGameConnection.onPing(this.getPong);
    mainGameConnection.onGetInitialStateResult(
      crashGameService.onGetInitialStateResult.bind(crashGameService)
    );
    mainGameConnection.onBetsClosed(crashGameService.handleBetsClosed.bind(crashGameService));
    mainGameConnection.onCashOutResult(crashGameService.handleCashOutResult.bind(crashGameService));
    mainGameConnection.on(
      GameLiveConnectionMethod.CashOutResultQueue,
      crashGameService.handleCashOutResultQueue.bind(crashGameService)
    );
    mainGameConnection.on(
      GameLiveConnectionMethod.DoBetResultQueue,
      crashGameService.handleDoBetResultQueue.bind(crashGameService)
    );
    mainGameConnection.onRoundFinished(crashGameService.handleRoundFin.bind(crashGameService));
    mainGameConnection.onDoBetResult(crashGameService.handleDoBetResult.bind(crashGameService));
    mainGameConnection.onRoundStarted(crashGameService.handleRoundStart.bind(crashGameService));
    mainGameConnection.onResultReport(crashGameService.handleResultReport.bind(crashGameService));
    mainGameConnection.onDoBetResultValidation(
      crashGameService.handleDoBetResultValidation.bind(crashGameService)
    );
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const crashGameConnection = new CrashGameConnection({ url: `${socketUrl}game` });
